/**
 * Copyright Highway9 Networks Inc.
 */
import type { MongoAbility } from "@casl/ability";
import { PermissionObject, type UserPermission } from "~/types/user";

/** CASL action names aligned with backend permission API. */
export type AppAction = UserPermission;

/** Re-export PermissionObject as the AppSubject value so callers use AppSubject.radio etc. */
export { PermissionObject as AppSubject };
/** AppSubject as a type is PermissionObject (enum member). Use this for hook/component args. */

export type PermissionsMap = { [key in PermissionObject]?: Partial<Record<UserPermission, boolean>> }

export type AppAbilities = [AppAction, PermissionObject | "all"];

export type AppAbility = MongoAbility<AppAbilities>;

/** CRUD-style aliases for common UI checks (maps to backend VIEW/ADD/EDIT/DELETE). */
export const CrudAction = {
  view: "VIEW",
  add: "ADD",
  edit: "EDIT",
  delete: "DELETE",
} as const satisfies Record<string, AppAction>;
